import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DoughnutChart from '@/components/share/DoughnutChart'
import BarChart from '@/components/share/BarChart'

export default {
  name: 'dashboard',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DoughnutChart,
    BarChart
  },
  computed: {
    credentials () {
      return this.$store.getters.credentials
    },
    user () {
      return this.$store.getters.user
    },
    isLogin () {
      return this.$store.getters.isSignedIn
    },
    avatar () {
      return this.$store.getters.avatar
    },
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      sidebar_tab: '1',
      loading: true,
      enterprise: {},
      tooltips: {
        max: 100,
        data: { complete: 0 }
      },
      guide: [],
      alerts: [],
      news: [],
      tabIndex: 0,
      info: '',
      isModal: false,
      modalInfo: {
        title: '',
        description: '',
        date: ''
      },
      intern: {},
      doughnutData: [0, 100],
      swipe: {
        barChart: {},
        invoice: {},
        month: [],
        selected: '',
        loading: false
      }
    }
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-light', 'text-primary']
      } else {
        return ['bg-light']
      }
    },
    openModal (data) {
      this.modalInfo = data
      this.isModal = true
    },
    setGuideUrl (item) {
      return `${this.env.GUIDE}/detail/enterprise/${item.guide_cd}`
    },
    setSwipe () {
      this.swipe.loading = true

      let body = {
        contractDate: this.swipe.selected.contractDate,
        nxtContractDate: this.swipe.selected.nxtContractDate
      }

      let additionalParams = {
        queryParams: {
          type: 'swipe'
        }
      }

      this.$apig.patch(this.$store.getters.api.LOGIN, {}, additionalParams, body)
        .then(response => {
          this.swipe.barChart = response.data.barChart
          this.swipe.invoice = response.data.invoice

          this.swipe.loading = false
        })
    }
  },
  mounted () {
    let body = {
      email: this.user.email
    }
    let additionalParams = {
      queryParams: {
        type: 'screen'
      }
    }
    this.$apig.patch(this.$store.getters.api.LOGIN, {}, additionalParams, body)
      .then(response => {
        this.enterprise = response.data.enterprise
        this.swipe.barChart = response.data.swipe.barChart
        this.swipe.invoice = response.data.swipe.invoice
        this.swipe.month = response.data.swipe.options
        if (response.data.swipe.options.length) this.swipe.selected = response.data.swipe.options[response.data.swipe.options.length - 1].value
        this.guide = response.data.guide
        this.tooltips.data = response.data.tooltips
        this.news = response.data.news
        this.doughnutData = [this.tooltips.data.complete, 100 - this.tooltips.data.complete]

        this.loading = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js